import { Button, ButtonProps } from '@mui/material'
import { ConfluencePage } from '../types'
import { OpenInNew } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

export interface ConfluencePageLinkButtonProps extends Omit<ButtonProps, 'children' | 'onClick'> {
  page: ConfluencePage
}

export default function ConfluencePageLinkButton({
  page,
  ...props
}: ConfluencePageLinkButtonProps): React.ReactElement {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  /**
   * Open the page in Confluence.
   */
  const openPageInConfluence = () => {
    window.open(`${page._links.base}${page?._links.webui}`, '_blank')
  }

  return (
    <Button
      variant="text"
      color="inherit"
      startIcon={<OpenInNew />}
      {...props}
      onClick={openPageInConfluence}
    >
      {t('openInConfluence')}
    </Button>
  )
}
